import { useContext, useMemo } from 'react';
import { useCollectionsPermissions } from '../useCollectionsPermissions';
import { useCollectionsLocation } from '../useCollectionsLocation';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';
import { computeDefaultDepartmentGroup, ALL_DEPARTMENTS_GROUP } from './departmentGroup';

export const useDepartmentGroupDefault = () => {
  const { user } = useContext(AuthenticationContext);
  const { isCollectionsAdmin } = useCollectionsPermissions();
  const location = useCollectionsLocation();
  // department_groups is keyed by location; the "My groups" filter only applies to the
  // active Collections location, so pick that location's groups (group_ids collide across locations).
  const rawGroups = useMemo(() => (location ? user?.department_groups?.[location] : []) ?? [], [user, location]);
  // ALL_DEPARTMENTS is a batch-email membership, not a filterable department: no client row is ever
  // tagged with it, so leaving it in myGroups made it the default for its only-member users and
  // opened the page on a filter matching nothing. Membership means "sees everything" instead.
  const myGroups = useMemo(() => rawGroups.filter((g) => g !== ALL_DEPARTMENTS_GROUP), [rawGroups]);
  const seesAllDepartments = isCollectionsAdmin || rawGroups.includes(ALL_DEPARTMENTS_GROUP);
  const defaultDepartmentGroup = useMemo(
    () => computeDefaultDepartmentGroup(seesAllDepartments, myGroups),
    [seesAllDepartments, myGroups],
  );
  const myGroupsLabel = useMemo(() => [...myGroups].sort().join(', '), [myGroups]);
  return { user, isCollectionsAdmin, myGroups, defaultDepartmentGroup, myGroupsLabel };
};
